<script setup lang="ts">
import ProgressBar from 'primevue/progressbar';
import { Stack, Typography } from '@apparatix/library/core';

type Props = {
  operation: 'generate' | 'load'
}

const props = defineProps<Props>();

</script>
<template>
  <Stack class="items-center w-full mt-6">
    <template v-if="props.operation === 'generate'">
      <Typography variant="heading">
        Generating Profile...
      </Typography>
      <Typography variant="body">
        Please wait while we generate your Profile. This can take a little while.
      </Typography>
      <Typography variant="body">
        You can stay on this page, or feel free to navigate elsewhere and return later.
      </Typography>
      <Typography variant="body">
        We'll notify you as soon as your profile is ready.
      </Typography>
      <ProgressBar mode="indeterminate" style="height: 10px; width: 100%;" />
    </template>
    <ProgressBar v-else mode="indeterminate" style="height: 5px; width: 100%;" />
  </Stack>
</template>
